export default __webpack_public_path__ + "static/media/mobile.5557f733.png";